<template>
  <div v-loading="loading">
    <task-form :disabled="disabled" :loading="loading" :detail="detail" @submit="handleSubmit"></task-form>
  </div>
</template>

<script>
import TaskForm from './components/TaskForm.vue'
import cpTaskService from '@/api/cpTask'
export default {
  name: 'CpTaskDetail',
  components: {
    TaskForm
  },
  data() {
    return {
      searching: false,
      detail: null,
      saving: false,
      disabled: false,
    }
  },
  computed: {
    loading() {
      return this.searching || this.saving
    }
  },
  created() {
    const { id: taskId, readonly } = this.$route.query
    if (taskId) {
      this.fetchData(taskId)
      this.disabled = !!readonly
    }
  },
  methods: {
    async fetchData(taskId) {
      this.searching = true
      try {
        const data = await cpTaskService.findById(+taskId)
        this.detail = data
      } catch (error) {
        this.$message({
          type: 'error',
          message: '获取版权入库任务详情异常: ' + error.message
        })
      }
      this.searching = false
    },
    async handleSubmit(postData) {
      this.saving = true
      try {
        const { id } = await cpTaskService.save(postData)
        this.$message.success('提交成功！')
        setTimeout(() => {
          this.$router.push({ name: 'cpTaskList', query: { id } })
        }, 1000)
      } catch (error) {
        console.error(error)
        this.$message({
          type: 'error',
          message: '提交失败: ' + error.message
        })
      }
      this.saving = false
    }
  }
}
</script>
